import { Injectable } from '@angular/core';
import { DatasourceTableService, DatasourceTableSettingsCheckService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { Y42FeatureType } from '@y42/json-schema';
import { UiModelingTableJobQuery } from '../../state';
import { UiModelingQuery, UiModelingStore } from '../../state/datasource';
import {
  UiModelingTableGitFactoryService,
  UiModelingTableQuery,
  UiModelingTableStore,
} from '../../state/datasource-table';

@Injectable({ providedIn: 'root' })
export class UiModelingTableService extends DatasourceTableService {
  constructor(
    parentStore: UiModelingStore,
    parentQuery: UiModelingQuery,
    query: UiModelingTableQuery,
    store: UiModelingTableStore,
    jobQuery: UiModelingTableJobQuery,
    gitFactory: UiModelingTableGitFactoryService,
    errorHandlerService: ErrorHandlerService,
    datasourceTableSettingsCheckService: DatasourceTableSettingsCheckService,
  ) {
    super({
      feature: Y42FeatureType.UiModel,
      parentStore,
      parentQuery,
      query,
      store,
      jobQuery,
      gitFactory,
      errorHandlerService,
      datasourceTableSettingsCheckService,
    });
  }
}
